import {Injectable} from '@angular/core';
import {IService} from '../IService';
import {PromotionMessageModel, PromotionMessageWizardModel} from '../../models/promotion-message.model';
import {HttpClientService} from '../httpClient/httpclient.service';
import {FormControl, Validators} from '@angular/forms';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class PromotionMessageService extends IService<PromotionMessageModel> {

  constructor(
    http: HttpClientService) {
    super(http, 'koncentro-promo', 'message')
  }

  /*
  * funzione createFiled, restituisce un FormControl
  * parametri:
  *
  * 1)  name: nome del form control, che verrà matchato con l'attributo name
  *     tra gli oggetti del file di configurazione
  *
  * 2)  configs: file di configurazione, array di oggetti che hanno come campi obbligatorio name
  *     e una serie di altri campi opzionali che definiscono le regole dei validatori (min,max/mandatory/readonly/default)
  *
  * 3)  overrideDefault: valore iniziale del campo del form control.
  *     Vengono comunque impostate le altre proprietà ad esempio readonly o mandatory, ma il valore
  *     iniziale sarà quello specificato qui. Questo serve perchè sennò in modifica di un record
  *     esistente, il suo valore di default viene sempre sovrascritto con quello preso dalla configurazione,
  *     perdendo le modifiche dell'utente
  *
  * 4)  flg: definisce se il campo in questione è un flag oppure no, perchè lo stato del flag nell'array di
  *     configurazione è trattato come "1" e "0"
  */
  createField(name: string, configs: any, overrideDefault: any = null, flg = false, date = false): FormControl {

    // console.log('--------------------------------');
    // console.log('CREO CAMPO ' + name.toString().toUpperCase());

    let defaultValue: any = null;
    let validators = [];
    let readOnly = false;
    let fl = 0;

    if (configs && configs.length > 0) {
      for (let elem of configs) {
        if (elem.name === name) {
          fl = 1;
          for (let prop in elem) {
            if (prop !== 'name') {
              // console.log('--------------------------------');
              // console.log('clausola ' + prop.toString());
              switch (prop) {
                case 'default': {
                  if (flg) {
                    // console.log('è un flag');
                    if (overrideDefault !== null) {
                      defaultValue = overrideDefault;
                      // console.log(prop + ' settato a valore entrata cioè ', defaultValue);
                    } else {
                      if (elem[prop] && elem[prop] !== null) {
                        defaultValue = elem[prop] === '1';
                        // console.log(prop + ' in base a 1 o 0 che mi arrivano, è stato settato a ', defaultValue);
                      }
                    }
                    break;
                  }
                  else if (date) {
                    // console.log('è un data');
                    if (overrideDefault !== null) {
                      defaultValue = overrideDefault;
                      // console.log(prop + ' settato a valore entrata cioè ', defaultValue);
                    } else {
                      if (elem[prop] && elem[prop] !== null) {
                        defaultValue = new Date(elem[prop]);
                        // console.log(prop + ' creato oggetto new Date() con il valore del DB, prop settata a ', defaultValue);
                      }
                    }
                    break;
                  } else {
                    if (overrideDefault !== null) {
                      defaultValue = overrideDefault;
                      // // console.log('Non sovrascrivo default perchè sono in modifica, perciò defaultValue rimane', defaultValue);
                    } else {
                      if (elem[prop] && elem[prop] !== null) {
                        // console.log('Clausola ' + prop + ' presente');
                        defaultValue = elem[prop];
                        // console.log('Clausola ' + prop + ' settata a ', defaultValue);
                      } else {
                        // console.log('Clausola ' + prop + ' non presente');
                      }
                    }
                    break;
                  }
                }
                case 'mandatory': {
                  if (elem[prop] && elem[prop] !== null) {
                    if (elem[prop] === true) {
                      // console.log('Clausola ' + prop + ' presente');
                      validators.push(Validators.required);
                      // console.log('Clausola ' + prop + ' impostata');
                    } else {
                      // console.log('Clausola ' + prop + ' non presente');
                    }
                  }
                  break;
                }
                case 'max': {
                  if (elem[prop] && elem[prop] !== null) {
                    // console.log('Clausola ' + prop + ' presente');
                    validators.push(Validators.max(elem[prop]));
                    // console.log('Clausola ' + prop + ' settata a ', defaultValue);
                  } else {
                    // console.log('Clausola ' + prop + ' non presente');
                  }
                  break;
                }
                case 'min': {
                  if (elem[prop] && elem[prop] !== null) {
                    // console.log('Clausola ' + prop + ' presente');
                    validators.push(Validators.min(elem[prop]));
                    // console.log('Clausola ' + prop + ' settata a ' + elem[prop]);
                  } else {
                    // console.log('Clausola ' + prop + ' non presente');
                  }
                  break;
                }
                case 'readonly': {
                  if (elem[prop] && elem[prop] !== null) {
                    if (elem[prop] === true) {
                      // console.log('Clausola ' + prop + ' presente');
                      readOnly = true;
                      // console.log('Clausola ' + prop + ' impostata');
                    } else {
                      // console.log('Clausola ' + prop + ' non presente');
                    }
                  }
                  break;
                }
              }
            }
          }
          if (elem['default'] === undefined) {
            return new FormControl({value: overrideDefault, disabled: readOnly}, validators)
          } else {
            return new FormControl({value: defaultValue, disabled: readOnly}, validators)
          }
        }
      }
      if (fl === 0) {
        /*prop non presente nei config*/
        if (flg) {
          // console.log('la propieta ' + name + ' non è presente nel file di configs, creato campo ' + name + ' col valore false visto che è un flg');
          return new FormControl(false);
        } else {
          // console.log('la propieta ' + name + ' non è presente nel file di configs, creato campo ' + name + ' col valore che aveva prima ' + overrideDefault);
          return new FormControl(overrideDefault);
        }
      }
    } else {
      /*file config vuoto o nullo*/
      if (flg) {
        // console.log('la propieta ' + name + ' non è presente nel file di configs, creato campo ' + name + ' col valore false visto che è un flg');
        return new FormControl(false);
      } else {
        // console.log('la propieta ' + name + ' non è presente nel file di configs, creato campo ' + name + ' col valore che aveva prima ' + overrideDefault);
        return new FormControl(overrideDefault);
      }
    }
  }

  create(model: PromotionMessageModel): Observable<PromotionMessageModel> {
    this.parseFromBooleanToChar(model);
    return super.create(model);
  }

  get(id) {
    return super.get(id).map(
      (result) => {
        this.parseFromCharToBoolean(result);
        return result
      }
    );
  }

  mergeConfigs(arrDef: PromotionMessageWizardModel[], arrDB: PromotionMessageWizardModel[]): PromotionMessageWizardModel[] {
    let arrayMerged: PromotionMessageWizardModel[] = [];
    for (let elem of arrDB) {
      const defaultFieldConfig = arrDef.find( field => field.name === elem.name );
      if (defaultFieldConfig) {
        arrayMerged.push(Object.assign({}, defaultFieldConfig, elem));
      } else {
        arrayMerged.push(elem)
      }
    }
    for (let elem of arrDef) {
      const defaultFieldConfig2 = arrayMerged.find( field => field.name === elem.name );
      if (!defaultFieldConfig2) {
        arrayMerged.push(elem);
      }
    }
    return arrayMerged;
  }

  update(model: PromotionMessageModel): Observable<PromotionMessageModel> {
    this.parseFromBooleanToChar(model);
    return super.update(model);
  }

  parseFromBooleanToChar(elem: any) {
    if (elem) {
      elem.flg_fidelity = elem.flg_fidelity === true ? '1' : '0';
      elem.flg_card_holder = elem.flg_card_holder === true ? '1' : '0';
      elem.flg_open_coupon = elem.flg_open_coupon === true ? '1' : '0';
    }
  }

  parseFromCharToBoolean(elem: any) {
    elem.flg_fidelity = elem.flg_fidelity === '1';
    elem.flg_card_holder = elem.flg_card_holder === '1';
    elem.flg_open_coupon = elem.flg_open_coupon === '1';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-message.service.ts